import { configureStore } from "@reduxjs/toolkit";
import wikiReducer from "./wiki";
import signalrReducer from "./signalr";
import spfSearchReducer from "./pesquisaAvancadaSpf";
import procedimentosSearchReducer from "./pesquisaAvancadaProcedimentos";
import advancedSearchReducer from "./pesquisaAvancada";
import executarOsSearchReducer from "./pesquisaAvancadaExecutarOs";
import parteServicoSearchReducer from "./pesquisaAvancadaParteServico";
import paginatedViewReducer from "./paginatedView";
import selectInputCacheReducer from "./selectInputCache";
import spedReducer from "./sped";
import procedimentoReducer from "./procedimentos";
import patSearchReducer from "./pesquisaAvancadaPat";

const store = configureStore({
  reducer: {
    wiki: wikiReducer,
    signalr: signalrReducer,
    spfSearch: spfSearchReducer,
    procedimentosSearch: procedimentosSearchReducer,
    advancedSearch: advancedSearchReducer,
    executarOsSearch: executarOsSearchReducer,
    parteServicoSearch: parteServicoSearchReducer,
    paginatedView: paginatedViewReducer,
    selectInputCache: selectInputCacheReducer,
    sped: spedReducer,
    procedimento: procedimentoReducer,
    patSearch: patSearchReducer,
  },
});

export default store;
